import styled from "styled-components";
import { colors, devicesNovo } from "../../../utils/styled/_variables.styled";

export const SonharMorarTeaserV2Container = styled.div`
  justify-self: center;
  max-height: 338px;
  max-width: 346px;
  height: 100%;
  width: 100%;
  @media (min-width: 769px) and (max-width: 900px) {
    height: 445px;
    width: 400px;
    max-height: unset;
    max-width: unset;
  }
  @media (min-width: 900px) {
    height: 445px;
    width: 522px;
    max-height: unset;
    max-width: unset;
  }
  .cmp-image {
    img {
      max-height: 242px;
      border-radius: 15px;
      @media ${devicesNovo.smallDesktop} {
        max-height: 289px;
      }
    }
  }
  .cmp-teaser__content {
    @media ${devicesNovo.smallDesktop} {
      display: flex;
      margin-top: 24px;
      height: 120px;
      flex-direction: column;
      justify-content: space-between;
    }
    div:nth-child(1) {
      > div > p {
        text-align: start;
        font-size: 16px;
        font-weight: 700;
        line-height: 150%;
        margin: 8px 0;
        color: ${colors.gray1};
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;

        @media (min-width: 1366px) {
          font-size: 24px;
          line-height: 36px;
          margin: unset;
        }
      }
    }

    div:nth-child(2) {
      > div > p {
        margin: unset !important;
        text-align: start;
        font-size: 16px;
        font-weight: 700;
        line-height: 28px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        a {
          color: ${colors.lilac};
          position: relative;
        }
        a::after {
          content: "";
          display: inline-block;
          width: 15px;
          height: 14px;
          background-image: ${`url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.89864 12.3678H12.1006C12.5224 12.3678 12.8675 12.0228 12.8675 11.601V7.76684C12.8675 7.34508 13.2125 7 13.6343 7C14.0561 7 14.4011 7.34508 14.4011 7.76684V12.3678C14.4011 13.2113 13.711 13.9015 12.8675 13.9015H2.13181C1.28829 13.9015 0.598145 13.2113 0.598145 12.3678V1.63218C0.598145 0.78866 1.28063 0.0985107 2.13181 0.0985107H6.7328C7.15456 0.0985107 7.49964 0.443585 7.49964 0.865343C7.49964 1.2871 7.15456 1.63218 6.7328 1.63218H2.89864C2.47688 1.63218 2.13181 1.97725 2.13181 2.39901V11.601C2.13181 12.0228 2.47688 12.3678 2.89864 12.3678ZM9.80014 1.63218C9.37838 1.63218 9.0333 1.2871 9.0333 0.865345C9.0333 0.443587 9.37838 0.0985107 9.80014 0.0985107H14.4011V4.69951C14.4011 5.12126 14.0561 5.46634 13.6343 5.46634C13.2125 5.46634 12.8675 5.12126 12.8675 4.69951V2.71341L5.86628 9.71459C5.56722 10.0137 5.08412 10.0137 4.78505 9.71459C4.48599 9.41553 4.48599 8.93242 4.78505 8.63336L11.7862 1.63218H9.80014Z" fill="%23AC41D8"/></svg>')`};
          background-size: contain;
          background-repeat: no-repeat;
          position: absolute;
          right: -22px;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
  }
`;
